import { Box, Typography } from "@mui/material"
import React from "react"
import NoInspectionData from "../../assets/NoInspectionData"
import { NoInspectionStyles } from "./styles"
export const NoInspectionImage = ({ message = "", note = "" }) => {
    const language = localStorage.getItem("i18nextLng")
    const classes = NoInspectionStyles();
    return (
        <Box className={language === "ar" ? `${classes.noInspection2}` : `${classes.noInspection}`}>
            <Box>
                <center>
                    <NoInspectionData />
                    <Typography className={`${classes.message}`}>{message}</Typography>
                    <Typography className={`${classes.note}`}>{note}</Typography>
                </center>
            </Box>
        </Box>
    )
}